module.exports = __webpack_public_path__ + "assets/delete-icon-userlist.15019fd83e9c7a8bc87876e32062e44d.svg";